import React, { useState, useContext, useEffect } from 'react';
import { TransactionFilterProvider } from 'src/context/transaction-filter-context';
import { SelectedTransactionProvider } from 'src/context/selected-transaction-context';
import { DownloadCSVProvider } from 'src/context/download-csv-context';
import { MerchantProfileContext } from 'src/context/merchant-profile-context';
import { TransactionsFilterForm, TerminalTransactionView } from 'src/components';
import TransactionList from './transaction-list/transaction-list';

import HeaderNav from '../header-nav/header-nav';

import 'src/sass/self-service-portal.scss';
import './terminal-transactions.scss';
import TealiumEvents from 'src/helpers/tealium-events';

export default function TerminalTransactions() {
  const { merchant } = useContext(MerchantProfileContext);
  const [filterItems, setFilterItems] = useState();

  useEffect(() => {
    TealiumEvents.terminalTransactionsPageLoadNewStyle();
  }, []);

  return (
    <div className="TerminalTransactions">
      <HeaderNav
        title={merchant?.companyName ? `Hi, welcome back ${merchant?.companyName}` : ''}
        screenName="Terminal transactions"
      >
        <TransactionFilterProvider>
          <SelectedTransactionProvider>
            <DownloadCSVProvider>
              <TransactionsFilterForm
                transactionTypes={filterItems?.transactionTypes}
                responseCodes={filterItems?.responseCodes}
                callingPage="terminal"
                title="Terminal Transaction History"
              >
                <TransactionList createFilterItems={(items) => setFilterItems(items)} />
              </TransactionsFilterForm>
            </DownloadCSVProvider>
            <TerminalTransactionView />
          </SelectedTransactionProvider>
        </TransactionFilterProvider>
      </HeaderNav>
    </div>
  );
}
